"use client";
import React from "react";
import "@/app/solutionslist.css";
import Image from "next/image";
import Link from "next/link";
import StartTrialBtn from "../StartTrialBtn";
import IndustryComponent from "@/component/SupplyChainAnalytics/IndustryComponent";
import AdvancedPredictiveAnalyticsIco from "@/Helper/images/advanced_predictive_analytics.svg";
import RealTimeVisibilitySolutionsIco from "@/Helper/images/real_time_visibility_solutions.svg";
import SupplierRiskAnalyticsIco from "@/Helper/images/supplier_and_risk_analytics.svg";
import ProcessOptimizationAutomationIco from "@/Helper/images/process_optimization_and_automation.svg";
import SustainabilityComplianceMonitoringIco from "@/Helper/images/sustainability_compliance_monitoring.svg";
import EnhancedTransparencyIco from "@/Helper/images/enhanced_transparency.svg";
import IntelligentProcessAutomationIco from "@/Helper/images/intelligent_process_automation.svg";
import SeamlessConnectivityIco from "@/Helper/images/seamless connectivity.svg";

// Importing images
import casestudy1 from "@/Helper/images/Banner/transforming_hr_analytics_with_power_BI_in_the_it_industry.png";
import casestudy2 from "@/Helper/images/Banner/revolutionizing_reporting_for_textile_manufacturing.png";
import casestudy3 from "@/Helper/images/Banner/supply_chain_analytics_transformation_for_manufacturing_client.png";

const caseStudies = [
  {
    image: casestudy1,
    alt: "Transforming HR Analytics with Power BI in the IT Industry",
    link: "/case-study-details-transforming-hr-analytics-with-power-bi-it-industry",
    title: "Transforming HR Analytics with Power BI in the IT Industry",
    description: "From Manual Excel Reports to Real-Time HR Insights for Proactive Decision-Making",
  },
  {
    image: casestudy2,
    alt: "Revolutionizing Reporting for Textile Manufacturing",
    link: "/case-study-details-revolutionizing-reporting-for-textile-manufacturing",
    title: "Revolutionizing Reporting for Textile Manufacturing",
    description: "Streamlining Reporting and Driving Operational Efficiency in the Textile Industry",
  },
  {
    image: casestudy3,
    alt: "Supply Chain Analytics Transformation for a Manufacturing Client",
    link: "/case-study-details-supply-chain-analytics-transformation-manufacturing-client",
    title: "Supply Chain Analytics Transformation for a Manufacturing Client",
    description: "Enhancing Supply Chain Insights and Efficiency",
  },

];
const SupplyChainAnalytics = () => {
  return (
    <>
      <section className="banner_bg1 supplychainanalyticsbg">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left">
              <h1 className="banner_heading1"> Streamline. Analyze. Optimize. </h1>
              <p className="banner_text1">  Empower your supply chain with actionable insights, advanced analytics, and seamless optimization for efficiency and resilience.</p>
              <div className="banner_btn_container">
                <StartTrialBtn Text={"Get Started Today"} />
              </div>
            </div>
          </div>
        </div>
      </section>
      

      <section className="common_solutionssection">
        <div className="container">
          <div class="common_titbox common_titboxcenter">
            <h2 class="common_hd">Our capabilities</h2>
          </div>
          <div className="solution_capablities">
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={AdvancedPredictiveAnalyticsIco}
                      alt="Advanced predictive analytics"
                    />
                  </div>
                  <h2 className="sol_listhd">Advanced predictive analytics</h2>
                </div>
                <p className="sol_list_desc">
                  Anticipate demand fluctuations and market changes with predictive models tailored to your supply chain. From demand forecasting to replenishment planning, our solutions optimize inventory levels and reduce shortages.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={RealTimeVisibilitySolutionsIco}
                      alt="Real-time visibility solutions"
                    />
                  </div>
                  <h2 className="sol_listhd">Real-time visibility solutions</h2>
                </div>
                <p className="sol_list_desc">
                  Track every segment of your supply chain in real-time, from suppliers and warehouses to distribution channels. Our real-time dashboards and alerts allow for quick, informed decision-making, enhancing transparency and operational control.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={SupplierRiskAnalyticsIco}
                      alt="Supplier and risk analytics"
                    />
                  </div>
                  <h2 className="sol_listhd">Supplier and risk analytics</h2>
                </div>
                <p className="sol_list_desc">
                  Evaluate supplier performance, identify risk factors, and mitigate potential disruptions with in-depth supplier analytics. Gain the insight to foster stronger supplier relationships and ensure continuity even in volatile conditions.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={ProcessOptimizationAutomationIco}
                      alt="Process optimization and automation"
                    />
                  </div>
                  <h2 className="sol_listhd">Process optimization and automation</h2>
                </div>

                <p className="sol_list_desc">
                  Leverage data to streamline workflows and automate repetitive processes across your supply chain. Our process analytics reduce bottlenecks, cut costs, and accelerate time-to-market.
                </p>
              </div>
            </div>
            <div className="sol_listbx">
              <div className="sol_list">
                <div className="sol_list_imgs">
                  <div className="sol_list_imgslft">
                    <Image
                      src={SustainabilityComplianceMonitoringIco}
                      alt="Sustainability and compliance monitoring"
                    />
                  </div>
                  <h2 className="sol_listhd">Sustainability and compliance monitoring</h2>
                </div>
                <p className="sol_list_desc">
                  Ensure compliance with environmental, social, and regulatory standards. Our analytics track sustainability metrics across your supply chain, helping you achieve goals while maintaining competitive performance.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      

      <section className="comm_indusreiessection mid_sec">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Your competitive edge</h2>
            <p class="common_desc">In a competitive landscape, data-driven decisions are critical for gaining an edge.<br /> Our supply chain analytics solutions empower you to:</p>
          </div>
          <div className="indus_chooseinner">

            <div className="indus_chooselist indus_chooselist1">
              <h3 className="indus_hd1">Enhance customer satisfaction</h3>
              <p className="indus_desc1">
                With better demand forecasting and reduced stockouts, you can keep your customers happy and loyal.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist2">
              <h3 className="indus_hd1">Optimize cost efficiency</h3>
              <p className="indus_desc1">
                Drive cost savings by reducing excess inventory, improving supplier selection, and automating key processes.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist3">
              <h3 className="indus_hd1">Increase agility and resilience</h3>
              <p className="indus_desc1">
                Be prepared for market disruptions with predictive insights and responsive supply chain strategies.
              </p>
            </div>
            <div className="indus_chooselist indus_chooselist4">
              <h3 className="indus_hd1">Drive innovation</h3>
              <p className="indus_desc1">
                Our tools enable continuous improvements and innovation across your supply chain, so you’re always ahead of the curve.
              </p>
            </div>

          </div>
        </div>
      </section>
      <section className="common_solutionssection ">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h3 className="common_hd">Results delivered</h3>
          </div>
          <div className="sol_bottominner">
            <div className="circle research">
              <div className="content">
                <div className="icon">
                  <Image
                    src={EnhancedTransparencyIco}
                    alt="Enhanced transparency"
                  />
                </div>
                <h2>Enhanced transparency</h2>
                <p>Gain visibility into your entire supply chain with real-time insights for proactive management and
                  improved coordination.</p>
              </div>
              <div className="arrow"></div>
            </div>

            <div className="circle time">
              <div className="content">
                <div class="icon">
                  <Image
                    src={SeamlessConnectivityIco}
                    alt="Seamless connectivity"
                  />
                </div>
                <h2>Seamless connectivity</h2>
                <p>Unify systems and data sources for streamlined decision-making and a fully synchronized, agile
                  supply chain.</p>
              </div>
              <div className="arrow"></div>
            </div>

            <div className="circle goal">
              <div className="content">
                <div className="icon">
                  <Image
                    src={IntelligentProcessAutomationIco}
                    alt="Intelligent process automation"
                  />
                </div>
                <h2>Intelligent process automation</h2>
                <p>Automate routine tasks to reduce errors, cut costs, and focus on high-impact initiatives.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="Landscape_img supplyLandscape_img"></div>
      <section className="common_solutionssection casestudy_outer1">
        <div className="container">
          <div className="common_titbox common_titboxcenter">
            <h2 className="common_hd">Case Studies</h2>
            {/* <p className="common_desc">A leading logistics company optimized warehouse efficiency and reduced costs by 25% through<br />
              advanced analytics, enhancing inventory placement, labor scheduling, and order fulfillment.</p> */}
          </div>
          <div className="casestudy_inner1">
  {caseStudies.map((study, index) => (
    <div className="casestudylist1" key={index}>
      <div className="casestudytop1">
        <Link href={study.link}>
          <Image
            src={study.image}
            alt={study.alt}
            width={380}
            height={340}
            loading="eager"
          />
        </Link>
      </div>
      <div className="casestudybottom1">
        <p className="case_bl_tihd1">
          <Link href={study.link}>{study.title}</Link>
        </p>
        <p className="case_bl_tidesc1">{study.description}</p>
      </div>
    </div>
  ))}
</div>

        </div>
      </section>
     
      
      <section className="industry_bg1">
        <div className="container industry_containerouter1">
        
          <div className="common_titbox common_titboxcenter"><h2 className="common_hd">Why Choose iKnot?</h2>
          </div>
          <IndustryComponent />
        </div>
      </section>
      <section className="cta_outer supplychaincta_bg">
        <div className="container cta_container">
          <div className="cta_inner">
            <div className="cta_innerout1">
              <div className="cta_left1">
                <h3 className="cta_hd">Ready to take your supply chain to the next level?</h3>
                <p className="cta_desc">
                  Get in touch with our experts for insights that streamline operations, optimize resources, and deliver measurable results.
                </p>
                <div className="banner_btn_container">
                  <StartTrialBtn Text={"Get Started"} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  );
};
export default SupplyChainAnalytics;